module.exports = __webpack_public_path__ + "static/media/backgroundMusic.12719109.ogg";